module.exports = __webpack_public_path__ + "static/media/house-night.1d82d667.svg";